module.exports = __webpack_public_path__ + "img/1518313082.94bee773.jpg";